// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".knowledgeSet-container[data-v-65f048bc] {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.knowledgeSet-container .filter-area[data-v-65f048bc] {\n    height: 40px;\n}\n.knowledgeSet-container .table-area[data-v-65f048bc] {\n    flex: 1;\n    overflow: hidden;\n}\n.knowledgeSet-container .staff-pagination[data-v-65f048bc] {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
